// This must all be in one single file, since different SCSS includes in here would each start from scratch wrt. to
// defined variables, i.e. they would not have Bootstrap variables etc. available w/o including them again.
import './sab2019.scss';

import LazyYoutubeEmbed from './Modules/lazy-youtube-embed';
import domready from 'domready';

// TODO migrate this to TypeScript
import './LegacyJs/main';
import './LegacyJs/tracking';
import './Components/ProductEnquiryModal';
import './Components/ProductCardsLoadMore';
import './Components/SideMenu';
import './Components/Lightbox';
import './Components/Icons';
import SectionMenu from './Components/SectionMenu';

import * as Sentry from '@sentry/browser';
import {BrowserOptions} from "@sentry/browser/types/client";

const sentryInfo = document.querySelector<HTMLDivElement>('#sentry');
if (sentryInfo !== null) {
    const sentryOptions: BrowserOptions = {
        dsn: sentryInfo.dataset['dsn'],

        environment: sentryInfo.dataset['environment'] ?? 'production',

        integrations: [
            new Sentry.BrowserTracing(),
        ],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.01,
        replaysOnErrorSampleRate: 0.5,
    };

    if (sentryInfo.dataset['release']) {
        sentryOptions['release'] = sentryInfo.dataset['release'];
    }
    // TODO make this lazy
    Sentry.init(sentryOptions);
} else {
    console.warn('Not initializing Sentry');
}

domready(() => {
    const youtubeEmbed: { replace(): void } = new LazyYoutubeEmbed();
    youtubeEmbed.replace();

    document
        .querySelectorAll<HTMLUListElement>('.frame-type-menu_sectionsticky ul')
        .forEach((el: HTMLUListElement) => new SectionMenu(el, 'li', 'active'));
    document
        .querySelectorAll<HTMLDivElement>('.product-data-details nav.sticky')
        .forEach((el: HTMLDivElement) => new SectionMenu(el, 'li', 'active', 0.05));
});
